(function() {
    'use strict';

    function ensureBenefitsElement(radioElement) {
        var benefits = radioElement.parentElement.querySelector('.subscription-benefits');
        if (!benefits) {
            benefits = document.createElement('div');
            benefits.className = 'subscription-benefits';
            benefits.innerHTML = 'Stick To Your Goals!<br>No Obligation: Cancel Or Modify Anytime<br>Auto-Delivered On Your Schedule';
            radioElement.after(benefits);
        }
        return benefits;
    }

    function updateBenefitsBackground(radioElement, benefits) {
        var subscriptionRadio = radioElement.querySelector('input[type="radio"][name="purchaseOption"][value="subscription"]');
        if (subscriptionRadio && subscriptionRadio.checked) {
            benefits.style.backgroundColor = 'var(--rc-active-background-color)';
        } else {
            benefits.style.backgroundColor = '';
        }
    }

    function bindRadioListeners(radioElement, benefits) {
        var radios = radioElement.querySelectorAll('input[type="radio"][name="purchaseOption"]');
        radios.forEach(function(radio) {
            if (radio.__subscriptionBenefitsBound) return;
            radio.__subscriptionBenefitsBound = true;
            radio.addEventListener('change', function() {
                updateBenefitsBackground(radioElement, benefits);
            });
        });
    }

    function enhanceRechargeWidget(radioElement) {
        if (!radioElement || radioElement.__subscriptionBenefitsEnhanced) return;
        radioElement.__subscriptionBenefitsEnhanced = true;

        var benefits = ensureBenefitsElement(radioElement);
        updateBenefitsBackground(radioElement, benefits);
        bindRadioListeners(radioElement, benefits);
    }

    function scanAndEnhance() {
        var radios = document.querySelectorAll('.rc-template__radio');
        radios.forEach(enhanceRechargeWidget);
    }

    function initRechargeSubscriptionEnhancements() {
        scanAndEnhance();
        
        // Observe the recharge widget for radio elements
        var rechargeWidget = document.querySelector('.recharge-subscription-widget');
        if (rechargeWidget) {
            observeRechargeWidget(rechargeWidget);
        }
    }
    
    function observeRechargeWidget(widgetElement) {
        // Check if radio element already exists
        var existingRadio = widgetElement.querySelector('.rc-template__radio');
        if (existingRadio) {
            scanAndEnhance();
            return;
        }
        
        // Observe the recharge widget for radio elements
        var observer = new MutationObserver(function(mutationList) {
            for (var i = 0; i < mutationList.length; i++) {
                var mutation = mutationList[i];
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach(function(node) {
                        if (!(node instanceof Element)) return;
                        
                        // Check if the added node is the radio element or contains it
                        if ((node.matches && node.matches('.rc-template__radio')) || 
                            (node.querySelector && node.querySelector('.rc-template__radio'))) {
                            observer.disconnect();
                            scanAndEnhance();
                        }
                    });
                }
            }
        });
        
        observer.observe(widgetElement, { childList: true, subtree: true });
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initRechargeSubscriptionEnhancements);
    } else {
        initRechargeSubscriptionEnhancements();
    }

    // Hook into Recharge initialization if available
    if (window.onRechargeLoad) {
        var existingOnRechargeLoad = window.onRechargeLoad;
        window.onRechargeLoad = function() {
            if (typeof existingOnRechargeLoad === 'function') {
                existingOnRechargeLoad.apply(this, arguments);
            }
            setTimeout(scanAndEnhance, 0);
        };
    }
})();


